import { useBulkEnrichment } from './useBulkEnrichment';
import { EnrichAssociatedRecords } from '../../EnrichAssociatedRecords/EnrichAssociatedRecords';
import { jsx as _jsx } from "react/jsx-runtime";
export function AssociatedRecords() {
  const {
    enrichAssociations,
    onToggleEnrichAssociations,
    isContactEnrichment
  } = useBulkEnrichment();
  function handleToggleEnrichAssociations() {
    onToggleEnrichAssociations();
  }
  return /*#__PURE__*/_jsx(EnrichAssociatedRecords, {
    associatedObjectType: isContactEnrichment ? 'company' : 'contact',
    checked: enrichAssociations,
    onChange: handleToggleEnrichAssociations
  });
}